import React from "react";

const NotFound = () => (
    <div>
        <h1>404</h1>
        <p>Page non trouvée</p>
    </div>
);

export default NotFound;